<template>
<el-dialog :title="msg('快递同步')" :visible.sync="visible" 
    :fullscreen="isMinScreen"
    :close-on-click-modal="false"
    append-to-body
    width="600px">
    <el-tag type="warning"><span style="font-size:15px;">快递同步前请确认已登录相关平台，如未登录，请点击对应平台进行登录</span></el-tag>
    <el-row style="margin-top:10px;margin-left:5px;">
        <el-col :xs="12" :sm="4">
            <el-link type="primary" href='https://login.taobao.com/member/login.jhtml' target="_blank">淘宝</el-link>
        </el-col>
        <el-col :xs="12" :sm="4">
            <el-link type="primary" href='https://mobile.yangkeduo.com/login.html' target="_blank">拼多多</el-link>
        </el-col>
        <el-col :xs="12" :sm="4">
            <el-link type="primary" href='https://login.1688.com' target="_blank">1688</el-link>
        </el-col>
    </el-row>
    <div style="text-align:center; margin-top: 20px;">
        <el-button type="success" size="mini" @click="onSubmit">{{msg('直接同步')}}</el-button>
        <el-button size="mini" v-on:click="close">{{msg('关闭')}}</el-button>
    </div>  
</el-dialog>
</template>

<script>

export default {
    name: 'SyncExpress',
    data(){
        return{
            visible: false,
        }
    }, 
    props: {
    },
    computed:{ 
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    mounted: function(){
    },
    methods:{
        showDialog(){
            this.visible = true;
        },
        onSubmit(){
            this.visible = false;
            this.$emit('finish');
        },
        close(){
            this.visible = false;
        }
    
    }
}
</script>

<style scoped lang="scss">

</style>
